import * as React from 'react';

const SvgIconSortNumberDescending = ({
  color = '#40180B',
  ...props
}: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 2.5H14.5V3V6V6.5H15H18.5V8.5H15H14.5V9.5H15H19H19.5V9V6V3V2.5H19H15ZM18.5 3.5V5.5H15.5V3.5H18.5ZM7.5 5.5V6V16.7929L9.64645 14.6464L10 14.2929L10.7071 15L10.3536 15.3536L7.35355 18.3536L7 18.7071L6.64645 18.3536L3.64645 15.3536L3.29289 15L4 14.2929L4.35355 14.6464L6.5 16.7929V6V5.5H7.5ZM17.5 11.7929V13V18.5H19H19.5V19.5H19H17H15H14.5V18.5H15H16.5V14.2071L15.3536 15.3536L15 15.7071L14.2929 15L14.6464 14.6464L16.6464 12.6464L17.5 11.7929Z"
      fill={color}
    />
  </svg>
);

export default SvgIconSortNumberDescending;
